module.exports = __webpack_public_path__ + "img/13.34fc98df.png";